import { useTranslation } from "react-i18next";
import { ApsCard, ApsCardBody, ApsCardHeader, ApsSelectList, ApsSelectListItem } from "UserExperience/portal-vnext";

const UploadCategory = ({category, categorySelected}) => {

  const { t } = useTranslation();

  return (
    <ApsCard
      key={category.nameTextId}
      cardLocation="home">
      <ApsCardHeader
        headerTitle={t(category.nameTextId)}
        role="heading"
      />
      <ApsCardBody>
        <ApsSelectList>
          {category.options && category.options.map((categoryOption) =>
          <ApsSelectListItem
            key={categoryOption.displayNameTextId}
            itemLabel={t(categoryOption.displayNameTextId)}
            onClick={() => categorySelected(categoryOption)}
            role="listitem"
            name="categoryItem"
          />)}
        </ApsSelectList>
      </ApsCardBody>
    </ApsCard>
  );
};

export default UploadCategory;